import React from "react";
import {
  Typography,
  Divider,
  Breadcrumbs,
  Link as MuiLink,
} from "@mui/material";
import { Link as RouterLink, useHistory } from "react-router-dom";
import { Helmet } from "react-helmet-async";

import { ROUTES } from "../../constants";
import { DynamicForm } from "../../dynamicForm/forms/DynamicForm";
import { useDynamicForm } from "../../dynamicForm/hooks/useDynamicForm";
import {
  CONNECTION_ROLE_FIELDS,
  newWaterServiceConnectionFormConfig,
  TYPE_OF_CONNECTION_FIELDS,
} from "../../dynamicForm/formConfigs/newWaterServiceConnectionFormConfig";
import {
  ContentSkeleton,
  ErrorCard,
  PageContainer,
} from "../../dynamicForm/components/ui";
import { makeExactlyOneValidator } from "../../dynamicForm/lib/utils";

function validateWaterServiceConnection(data) {
  return [
    ...makeExactlyOneValidator(
      TYPE_OF_CONNECTION_FIELDS,
      "Select exactly one type of connection"
    )(data),
    ...makeExactlyOneValidator(
      CONNECTION_ROLE_FIELDS,
      "Select either Owner or Builder"
    )(data),
  ];
}

const IS_NEW = true;
const FORM_NDX = null;

export default function NewWaterServiceConnectionPage() {
  const history = useHistory();
  const redirectPath = ROUTES.PUBLIC_FORMS;

  const handleRedirect = () => history.push(redirectPath);

  const { isFetching, error, refetchFormData, refetchLookups, ...rest } =
    useDynamicForm({
      ndx: FORM_NDX,
      isNewRecord: IS_NEW,
      config: newWaterServiceConnectionFormConfig,
      endpoints: { submit: "/water-service-connection" },
      handleRedirect,
      onSuccess: () => {},
      customValidate: validateWaterServiceConnection,
    });

  const pageTitle = "Water Service Connection";

  return (
    <>
      <Helmet>
        <title>{pageTitle}</title>
      </Helmet>

      <Typography variant="h3" gutterBottom>
        {pageTitle}
      </Typography>

      <Breadcrumbs sx={{ mt: 4 }} aria-label="Breadcrumb">
        <MuiLink component={RouterLink} to={ROUTES.LANDING}>
          Home
        </MuiLink>
        <MuiLink component={RouterLink} to={ROUTES.PUBLIC_FORMS}>
          Forms
        </MuiLink>
        <Typography>{pageTitle}</Typography>
      </Breadcrumbs>

      <Divider sx={{ my: 6 }} />

      <PageContainer>
        {error ? (
          <ErrorCard
            onRetry={() => Promise.all([refetchFormData(), refetchLookups()])}
            isFetching={isFetching}
          />
        ) : isFetching ? (
          <ContentSkeleton />
        ) : (
          <DynamicForm config={newWaterServiceConnectionFormConfig} {...rest} />
        )}
      </PageContainer>
    </>
  );
}
